import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import Customizable from "./CustomizableComponent";
export class LearnMore extends Component {
  static displayName = LearnMore.name;

  constructor(props) {
    super(props);
    this.toggleProp = this.toggleProp.bind(this);
    this.state = {
      readMoreDescription: false,
    };
  }

  toggleProp(name) {
    let propVal = !this.state[name];
    this.setState({
      ...this.state,
      [name]: propVal,
    }); 
  }
  render() {
    return (
      <div>
        <div className="RowContent">
          <Col md={12} className="card-style">
            <Row md={12} className="card-style-padding">
              <Col
                md={12}
                sm={12}
                className="text-left p-lg-5 pResize"
                style={{ fontSize: "1rem" }}
              >
                <Customizable name="LearMoreText" editable={false} />
                <div>
                  
                </div>
              </Col>
            </Row>
          </Col>
        </div>
      </div>
    );
  }
}
